
<script>
// 近期比赛
import { QNImageUtil } from '@/utils'

export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
      return {

      };
  },
  methods: {
    getLogoUrl(url) {
      return QNImageUtil.originView(url) || ''
    },
    onItemClick(item) {
      this.$router.push({ path: `/event/activity?gameId=${item.id}` })
    }
  },
};
</script>

<template>
  <div class="recent-games-container flex">
    <div class="recent-games-item bg1 padding-12" v-for="item in list" :key="item.id" @click="onItemClick(item)">
      <div class="name font-color3 overflow-text">{{ item.name }}</div>
      <div class="team-box">
        <div class="team-info vertical-center">
          <img class="logo" :src="getLogoUrl(item.home.logUrl)" alt="logo" />
          <div class="team-name overflow-text">{{ item.home.name }}</div>
          <div class="score">{{ item.home.score }}</div>
        </div>
        <div class="team-info vertical-center">
          <img class="logo" :src="getLogoUrl(item.away.logUrl)" alt="logo" />
          <div class="team-name overflow-text">{{ item.away.name }}</div>
          <div class="score" v-if="item.away.score">{{ item.away.score }}</div>
        </div>
      </div>
      <div class="bottom flex">
        <div class="status text-center color-white" :class="`status-${item.status}`" v-if="item.status != -1">{{ item.statusLabel }}</div>
        <div class="time font-color3">{{ item.time }}</div>
      </div>
    </div>
  </div>
</template>

<style src="@/tbs/stylesheet/dynamic.css" />
<style scoped lang="scss">
.recent-games-container {
  overflow-x: scroll;
  gap: 10px;
  &::-webkit-scrollbar { display: none; }
}
.recent-games-item {
  min-width: 245px;
  border-radius: 4px;
  .name { font-size: 13px; margin-bottom: 3px; }
  .team-box .team-info {
    height: 40px;
    gap: 7px;
    .logo { width: 30px; height: 30px; border-radius: 50%; }
    .team-name { font-size: 15px; flex: 1; }
    .score { color: #16447C; font-size: 17px; }
  }
  .bottom {
    margin-top: 3px;
    gap: 8px;
    .status {
      width: 47px;
      height: 18px;
      font-size: 11px;
      line-height: 18px;
      border-radius: 2px;
    }
    .status-0{
      background-color: #E6A23C;
    }
    .status-1{
      background-color: #C30D23;
    }
    .status-2{
      background-color: #529B2E;
    }
    .time{
      font-size: 13px;
    }
  }
}
</style>
